import { hasLicense } from "@common/utils/user";
import { AccountEntitlementOptionKeys } from "@services/account/types";
import { AuthenticatedUser } from "@services/user/types";

const reportLicensesKeys: AccountEntitlementOptionKeys[] = [
  "reports",
  "buildYourOwnReports",
];

export const hasNoReportLicenses = (account: AuthenticatedUser["account"]) => {
  const hasNoLicense = (key: AccountEntitlementOptionKeys) =>
    !hasLicense(account, key);

  return reportLicensesKeys.every(hasNoLicense);
};
